/**
 *Created by jmmartinez on 18/10/19
 * v1.1 06/11/2019 Modificado el criterio de renderizado, para que se pinten siempre los items sin id.
 * v1.2 17/03/2020 Añadido uso de prefijoAccionesAuth de la configuracion en la comparación para renderizar.
 *                 Eliminada la prop. acciones y la obtenemos del redux auth.
 * v1.3 18/03/2020 Modificado render para calcular el idConPrefijo correcto para cuando no hay prefijo
 * v1.4 20/03/2020 Si es JPA, las acciones se obtienen de auth.acciones, si no de auth.paginas.
 * v1.5 25/03/2020 Modificado getMenuItem para mostrar el submenú cuando exista la propiedad children
 * v1.6 10/04/2020 Modificada detección, añadiendo al include " " en los extremos para buscar palabra exacta
 * v2.0 30/09/2020 Cambiado a framework2
 * **/

import React from 'react'
import PropTypes from 'prop-types';
import connect from "react-redux/es/connect/connect";
import {Menu} from "@blueprintjs/core";
import {prefijoAccionesAuth, tipoPasarela} from "../../dental/Configuracion";
import {estadoChangeTab, estadoLimpiar} from "../../dental/redux/estado/actions";

class MenuLateralItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }


    click = (paginaId) => {
        const {funcionDispatchOnClick} = this.props;

        //ELiminamos los datos  del estado para que al pinchar en el menú se trate correctamente
        //COMENTADO EL 01/05/2025
        //this.props.dispatch(estadoLimpiar());

        if (funcionDispatchOnClick)
            this.props.dispatch(funcionDispatchOnClick(paginaId));
    }

    getMenuItem = () => {
        const {paginaId, icon, text, children} = this.props;
        //console.log("getMenuItem:");
        //console.log("text: ", text);
        if (!children)
            return <Menu.Item icon={icon} onClick={() => this.click(paginaId)} text={text}/>
        else
            return <Menu.Item icon={icon} text={text}>
                     {children}
                   </Menu.Item>
    }


    render() {
        const {auth, id} = this.props;
        let acciones= auth.acciones;

        if (tipoPasarela === "JPA")
            acciones= auth.acciones;
        let idConPrefijo= prefijoAccionesAuth ? prefijoAccionesAuth + "_" + id : id;

        /*
        console.log("MenuLateralItem:");
        console.log("Id: ", id);
        console.log("IdConPrefijo: ", idConPrefijo);
        console.log("Acciones: ", acciones);
        console.log("funcion: ", acciones && acciones.includes(idConPrefijo));
        */

        return (
            <>
            {   (!id || (acciones && acciones.includes(" " + idConPrefijo + " "))  ) &&
                this.getMenuItem()
            }
            </>
        );
    }
}


MenuLateralItem.propTypes = {
    //acciones: PropTypes.string,
    id: PropTypes.string,
    icon: PropTypes.string,
    paginaId: PropTypes.string,
    text: PropTypes.string,
    funcionDispatchOnClick: PropTypes.func,
    oculta:PropTypes.bool,
}


const mapStateToProps = function(state) {
    return {
        auth: state.auth
    }
}

//Necesitamos hacer el connect para poder hacer Dispatchs
export default connect(mapStateToProps)(MenuLateralItem);